import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import dataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router'
import axios from 'axios'
import common from './assets/utils/common'
import 'default-passive-events'
import EventBus from './assets/utils/EventBus';
Vue.prototype.$common = common
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
	
	if(config.method=='get'){
		
		if(config.params){
			if(!config.params.deptLevel && !config.params.adely){
				config.params.startDate=sessionStorage.getItem('startDate');
				config.params.endDate=sessionStorage.getItem('endDate');
				config.params.provinceCode=sessionStorage.getItem('provinceCode');
				config.params.cityCode=sessionStorage.getItem('cityCode');
				config.params.districtCode=sessionStorage.getItem('districtCode');
				config.params.townshipCode=sessionStorage.getItem('townshipCode');
			}
		}
		else {
			config.params={
				startDate:sessionStorage.getItem('startDate'),
				endDate:sessionStorage.getItem('endDate'),
				provinceCode:sessionStorage.getItem('provinceCode'),
				cityCode:sessionStorage.getItem('cityCode'),
				districtCode:sessionStorage.getItem('districtCode'),
				townshipCode:sessionStorage.getItem('townshipCode'),
			}
		}
	}
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    if(response.data.code==1){
      return response
    }
    if(response.data.code==0){
      alert(response.data.msg)
	  return response
    }
    if(response.data.code==201){
      window.sessionStorage.token = '';

      axios.defaults.headers.common["Authorization"] = ''

      bus.$emit('login');
    }
    // 对响应数据进行处理

  },
  function (error) {
    // 对响应错误进行处理
    return Promise.reject(error);
  }
);
Vue.prototype.$axios = axios
Vue.use(ElementUI);
Vue.use(dataV);
Vue.use(EventBus);
new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
